<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <main class="main">
        <div :style="{ backgroundColor: sfondoBody }">&nbsp;</div>
        <!-- style="background-color: #D7E4F2" -->
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid" :style="{ backgroundColor: sfondoBody, height: '100%' }">
          <!-- style="background-color: #D7E4F2;height:100%" -->
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
    <!--<AppFooter/>-->
  </div>
</template>

<script>
// import nav from "../_nav";
import menuService from "../services/backend/menuService";
import {
  Header as AppHeader,
  Sidebar,
  Aside as AppAside /*,
  Footer as AppFooter,
  Breadcrumb*/
} from "../components/";
// import jsonHelper from "../shared/jsonHelper";
import { mapActions, mapGetters } from "vuex";
import dashboardService from "../services/backend/dashboardService";
import colorsService from "../services/backend/colorsService";
import projectService from "../services/backend/projectService";

export default {
  name: "Full",
  components: {
    AppHeader,
    Sidebar,
    AppAside /*,
    AppFooter,
    Breadcrumb*/
  },
  data() {
    return {
      navFromServer: [],
      navFromProjects: [],
      appsList: [],
      coloreSfondo: "",
      sfondoBody: "",
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects", "recentProjects"]),
    ...mapGetters("_colorsModule", ["cardColors", "bodyColors"]),
    navItems: function() {
      var ret = [];

      ret.push({
        name: "S626",
        title: true
      });

      this.navFromServer.forEach(element => ret.push(element));

      ret.push({
        divider: true
      });

      ret.push({
        name: "S1146",
        title: true
      });

      this.navFromProjects.forEach(element => ret.push(element));

      return ret;
    }
    /*name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },*/
  },

  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },

  mounted: function() {
    var that = this;

    if (that.cardColors != null || that.cardColors != undefined) {
      that.coloreSfondo = that.cardColors[0] + " !important";
    }

    if (that.bodyColors != null || that.bodyColors != undefined) {
      that.sfondoBody = that.bodyColors[0];
    }

    dashboardService.getApps().then(function(data) {
      data.forEach(app => {
        app.modalities.forEach(modality => {
          that.appsList.push({
            id: modality.id,
            name: app.name + ", " + that.uniTranslation(modality.name)
          });
        });
      });

      //alert(JSON.stringify(that.appsList));

      menuService.getMenuItems().then(function(data) {
        that.navFromServer = data;
      });

      that.refreshProjects();

      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          if (mutation.type === "loadProject" || mutation.type === "removeProject") {
            that.refreshProjects();
          }
        })
      );
    });
  },
  methods: {
    ...mapActions("_colorsModule", ["getColoriBodyAction", "getColoriCardAction"]),
    getMessage: function(key) {
      return this.uniTranslation(key);
    },
    refreshProjects: async function() {
      //----------------------------------------
      var that = this;
      let resPrjs = [];
      let resPrjsId = [];
      let project = that.recentProjects; //projects;
      let prjs = {};

      for (let el in project) {
        prjs = project[el];
        if (prjs) {
          resPrjs.push(prjs);
          resPrjsId.push(prjs.projectId);
        }
      }

      resPrjs = resPrjs.reverse();
      //----------------------------------------

      var dbProjects = [];
      /*await projectService.listProjectsById(resPrjsId).then(list => {
        dbProjects = list;
      });*/
      //----------------------------------------

      that.navFromProjects = [];

      if (dbProjects != null) {
        resPrjs.forEach(prj => {
          if (prj.modality != undefined) {
            var modStr = that.appsList.find(el => el.id == prj.modality).name;
            var isPresent = dbProjects.find(el => el.projectId == prj.projectId);
            if (isPresent) {
              that.navFromProjects.push({
                name: prj.name,
                state: {
                  name: "ViewProject",
                  params: {
                    modality: prj.modality,
                    projectId: prj.projectId
                  }
                },
                icon: "fa fa-file-text",
                badge: { text: modStr, variant: "secondary" },
                modality: prj.modality,
                projectId: prj.projectId
                /*children: [{
                name: prj.name + '_close',
                state: {
                  name:'CloseProject', params: {
                    modality: prj.modality,
                    projectId: prj.projectId
                  }
                },
                icon: 'fa fa-file-text',
                modality: prj.modality,
                projectId: prj.projectId,
              }]*/
              });
            }
          }
        });
      }
    }
  }
};
</script>

<style>
.el-input__icon {
  line-height: 16px !important;
}
</style>
